export enum OTP_VALIDATION_TYPE {
  userLogin = 'userLogin',
  userOnboard = 'userOnboard',
  partnerLogin = 'partnerLogin'
}
